// @flow

export const dataKey: 'vending' = 'vending';
